import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function UpdateForm15Success(props: any) {
    const { reqId = '' } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.UpdateForm15.Success.back}
                infospan2={`${reqId}`}
                handleClick={() => props.history.push('/portal/track')}
            />
        </div>
    );
}
